import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UserTopbar from '../component/UserTopbar'
import { BiCalendarPlus } from "react-icons/bi";
import { BiErrorCircle, BiSolidTrash, BiGift, BiUserPlus, BiCheckCircle, BiSearchAlt, BiX } from "react-icons/bi";
import { PiMicrosoftExcelLogoDuotone } from "react-icons/pi";
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Button';
import { useForm, SubmitHandler } from "react-hook-form"
import { useSearchParams } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { MultiSelect } from "react-multi-select-component";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../component/LoadingScreen';
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { acquireGetAccessToken } from "../utils/GetGrapApi";
import * as XLSX from "sheetjs-style";
import * as FileSaver from 'file-saver';

import { Buffer } from 'buffer';
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import { callMsGraph } from '../callMsGroup';

interface IFormInput {
    id: string,
    eventNumber: string,
    eventName: string,
    description: string,
    startDate: string,
    endDate: string,
    status: string,
    ConfirmStatus:string,
    BehalStatus: string,
    eventOwner: string,
    file: any
}
interface IFormRewardInput {
    eventId: string,
    rewardName: string,
    file: any,
    qty: string
}
interface IFormMemberInput {
    inputtype: string,
    employeeId: string,
    rewardNumber: string,
    file: any
}




function SuccessModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header >
                <Modal.Title id="contained-modal-title-vcenter text-center" className={`w-100 text-center ${(props.result === "1") ? "text-success" : "text-danger"}`}>
                    {(props.result === "1") ? <>The data has been successfully saved.</> : <>Data saving failed.</>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
                <p>
                    {(props.result === "1") ? <>Your activity has been successfully created.</> : <>Unable to create your activity. Please try again.</>}

                </p>
            </Modal.Body>
            <Modal.Footer>
                {(props.result === "1") ? <a className='btn btn-primary' href={`/events?id=${props.eventId}`}>OK</a> : <Button onClick={props.onHide}>OK</Button>}

            </Modal.Footer>
        </Modal>
    );
}
function RewardConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Confirm
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                Are you sure you want to delete this data?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
                <Button onClick={props.onDelete}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}
function MemberConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Confirm
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to delete this data?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
                <Button onClick={props.onDelete}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}
function BulkDeleteConfirmModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    ยืนยันการลบ
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล {props.count} รายการที่เลือก?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>ยกเลิก</Button>
                <Button variant="danger" onClick={props.onDelete}>ลบทั้งหมด</Button>
            </Modal.Footer>
        </Modal>
    );
}
function DeleteAllConfirmModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="text-danger">
                    ⚠️ ยืนยันการลบทั้งหมด
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">
                    <strong>คำเตือน:</strong> คุณกำลังจะลบสมาชิกทั้งหมดที่แสดงในรายการปัจจุบัน
                </p>
                {props.filters && (props.filters.keyword || props.filters.status) ? (
                    <div className="alert alert-warning">
                        <strong>Filter ที่ใช้อยู่:</strong>
                        <ul className="mb-0 mt-2">
                            {props.filters.keyword && <li>คำค้นหา: "{props.filters.keyword}"</li>}
                            {props.filters.status && <li>สถานะ: {props.filters.status === '1' ? 'Received' : 'Not Received'}</li>}
                        </ul>
                    </div>
                ) : (
                    <div className="alert alert-danger">
                        <strong>จะลบสมาชิกทั้งหมด ({props.total} รายการ) ในอีเว้นท์นี้</strong>
                    </div>
                )}
                <p className="text-danger mb-0">
                    <strong>การดำเนินการนี้ไม่สามารถย้อนกลับได้!</strong>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>ยกเลิก</Button>
                <Button variant="danger" onClick={props.onDelete}>ยืนยันการลบทั้งหมด</Button>
            </Modal.Footer>
        </Modal>
    );
}
function Events(props: any) {
    const navigate = useNavigate();
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [id, setId] = useState("00");
    const [rewardId, setRewardId] = useState(0);
    const [createEvId, setCreateEvId] = useState("");
    const [memberId, setMemberId] = useState(0);
    const [rewardLists, setRewardLists] = useState([]);
    const [memberLists, setMemberLists] = useState<{ memberLists: any[], offset: number, limit: number, totalPages: number, total: number }>({ memberLists: [], offset: 0, limit: 5, totalPages: 0, total: 0 });
    const [totalMembersInEvent, setTotalMembersInEvent] = useState(0);
    const [totalReceivedInEvent, setTotalReceivedInEvent] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const eventId = searchParams.get("id");
    const [rewardModalShow, setRewardModalShow] = useState(false);
    const [memberModalShow, setMemberModalShow] = useState(false);
    const [successModalShow, setSuccessModalShow] = useState(false);
    const [createStatus, setCreateStatus] = useState("");
    const { register, handleSubmit, setValue } = useForm<IFormInput>()
    const { register: registerReward, handleSubmit: submitReward, reset: resetReward } = useForm<IFormRewardInput>()
    const { register: registerMember, handleSubmit: submitMember, reset: resetMember } = useForm<IFormMemberInput>()
    const [memberInputType, setMemberInputType] = useState(1);
    const [rewardOptions, setRewardOptions] = useState([]);
    const [rewardSelected, setRewardSelected] = useState([]);
    const [memberErrorStatus, setMemberErrorStatus] = useState(false);
    const [memberErrorMessage, setMemberErrorMessage] = useState("ไม่สามารถเพิ่มพนักงานได้ กรุณาตรวจสอบข้อมูลให้ถูกต้อง");
    const [memberSuccessStatus, setMemberSuccessStatus] = useState(false);
    const [memberSuccessMessage, setMemberSuccessMessage] = useState("เพิ่มรายชื่อพนักงานเรียบร้อยแล้ว");
    const [memberGroup, setMemberGroup] = useState(0);
    const [filter, setFilter] = useState({ offset: 0, limit: 18 });
    const [searchKeyword, setSearchKeyword] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [memberUploading, setMemberUploading] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState<number[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [bulkDeleteModalShow, setBulkDeleteModalShow] = useState(false);
    const [deleteAllModalShow, setDeleteAllModalShow] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [emailList, setEmailList] = useState<string[]>([]);
    const [currentEmail, setCurrentEmail] = useState("");
    const [ownerSuggestions, setOwnerSuggestions] = useState<{ displayName: string; mail: string }[]>([]);
    const [ownerSearchLoading, setOwnerSearchLoading] = useState(false);
    const ownerSearchTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [previewImage, setPreviewImage] = useState<string>("");
    const tokensesSionStorage = sessionStorage.getItem("accessToken");
    const { inProgress, instance, accounts } = useMsal();
    const [token, setToken] = useState("");
    const [profile, setProfile] = useState({ jobTitle: "", mail: "" });
    const [photoData, setPhotoData] = useState("");
    const [tokenProfile, setTokenProfile] = useState("");
    const [stateLoad, setStateLoad] = useState(false);
    const [eventdata, setEventdata] = useState({
        owner: "",
    })
    const auth = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        },
    };
    const authPut = {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        },
    };

    
    const onSubmit: SubmitHandler<IFormInput> = (data) => {
        setLoading(true)
        
        // Validation for required fields when creating new event
        if (eventId === null) {
            // Check if Event Name is provided
            if (!data.eventName || data.eventName.trim() === '') {
                alert('Event Name is required');
                setLoading(false);
                return;
            }
            
            // Check if Start Date is provided
            if (!data.startDate) {
                alert('Start Date is required');
                setLoading(false);
                return;
            }
            
            // Check if End Date is provided
            if (!data.endDate) {
                alert('End Date is required');
                setLoading(false);
                return;
            }
            
            // Check if Event Image is provided
            if (!data.file || data.file.length === 0) {
                alert('Event Image is required');
                setLoading(false);
                return;
            }
            
            // Check if Event Owner(s) is provided
            if (emailList.length === 0) {
                alert('At least one Event Owner email is required');
                setLoading(false);
                return;
            }
        }
        
        // Validate date range (for both create and edit)
        if (data.startDate && data.endDate) {
            const startDate = new Date(data.startDate);
            const endDate = new Date(data.endDate);
            
            if (endDate < startDate) {
                alert('End Date cannot be earlier than Start Date. Please select valid dates.');
                setLoading(false);
                return;
            }
        }

        console.log('memberLists=',memberLists);
        
        // Clean up event owner emails - use emailList instead of data.eventOwner
        const cleanEventOwner = emailList.join(';');
        
        var eventFormData = new FormData();
        eventFormData.append("eventName", data.eventName);
        eventFormData.append("description", data.description);
        eventFormData.append("startDate", data.startDate);
        eventFormData.append("endDate", data.endDate);
        eventFormData.append("status", data.status);
        eventFormData.append("ConfirmStatus", data.ConfirmStatus);
        eventFormData.append("BehalStatus", data.BehalStatus);
        eventFormData.append("eventOwner", cleanEventOwner);
        eventFormData.append("file", data.file[0]);
        if (eventId != null) {
            eventFormData.append("id", data.id);
            eventFormData.append("eventNumber", data.eventNumber);
            axios.put(process.env.REACT_APP_API_END_POINT + '/v1/Events/update', eventFormData,authPut).then(function (response) {
                setSuccessModalShow(true)
                setCreateEvId(response.data.eventNumber);
                setCreateStatus("1")
                setLoading(false)
            }).catch(function (error) {
                setSuccessModalShow(true)
                setCreateEvId("");
                setCreateStatus("0")
                setLoading(false)
            });
        } else {
            //console.log('data=',data);
            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/Events/create', eventFormData, authPut).then(function (response) {
                setLoading(false)
                setSuccessModalShow(true)
                setCreateEvId(response.data.eventNumber);
                setCreateStatus("1")

            })
                .catch(function (error) {
                    setLoading(false)
                    setSuccessModalShow(true)
                    setCreateEvId("");
                    setCreateStatus("0")
                });
        }


    }
    const onSubmitReward: SubmitHandler<IFormRewardInput> = (data) => {
        setLoading(true)
        var rewardForm = new FormData();
        rewardForm.append("eventId", id.toString());
        rewardForm.append("rewardName", data.rewardName);
        rewardForm.append("qty", data.qty);
        rewardForm.append("file", data.file[0]);
        axios.post(process.env.REACT_APP_API_END_POINT + '/v1/reward/create', rewardForm,authPut).then(function (response) {
            setLoading(false)
            loadReward()
            resetReward()
            //console.log(response);
        }).catch(function (error) {
            setLoading(false)
           // console.log(error);
        });

    }

    const onSubmitMember: SubmitHandler<IFormMemberInput> = (data) => {
        setMemberUploading(true)
        var selectedRewards = rewardSelected.map((o: any) => o.value).join(',');
        var memberForm = new FormData();
        memberForm.append("eventId", id.toString());


        if (memberInputType.toString() === "1") {
            memberForm.append("employeeId", data.employeeId);
            memberForm.append("rewardNumber", selectedRewards);
            if (selectedRewards !== "" && data.employeeId !== "") {
                axios.post(process.env.REACT_APP_API_END_POINT + '/v1/member/add', memberForm, authPut).then(function (response) {
                    setMemberUploading(false)
                    loadMember()
                    resetMember()
                    setRewardSelected([])
                    setMemberSuccessStatus(true)
                    setMemberErrorStatus(false);
                }).catch(function (error) {
                    setMemberUploading(false)
                    setMemberErrorStatus(true);
                    setMemberSuccessStatus(false)
                    //setMemberErrorMessage(error.response.data.detailTh);
                });
            } else {
                setMemberUploading(false)
                setMemberErrorStatus(true)
            }
        } else if (memberInputType.toString() === "2") {
            memberForm.append("Limit", "12");
            memberForm.append("Offset", "0");
            memberForm.append("BatchNo", "1");
            memberForm.append("file", data.file[0]);
            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/Upload/ImportExcel', memberForm, authPut).then(function (response) {
                setMemberUploading(false)
                loadMember()
                loadTotalMembers()
                resetMember()
                setRewardSelected([])
                setMemberSuccessStatus(true)
                setMemberErrorStatus(false);
            }).catch(function (error) {
                setMemberUploading(false)
                setMemberErrorStatus(true);
                setMemberSuccessStatus(false)
                // Display error message from API
                if (error.response?.data?.Error) {
                    setMemberErrorMessage(error.response.data.Error);
                } else if (error.response?.data?.detailTh) {
                    setMemberErrorMessage(error.response.data.detailTh);
                } else if (error.response?.data?.message) {
                    setMemberErrorMessage(error.response.data.message);
                } else {
                    setMemberErrorMessage('ไม่สามารถอัพโหลดไฟล์ได้ กรุณาตรวจสอบรูปแบบไฟล์และข้อมูลให้ถูกต้อง');
                }
            });
        } else {

            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/member/allEmployee', memberForm, authPut).then(function (response) {
                setMemberUploading(false)
                loadMember()
                resetMember()
                setRewardSelected([])
                setMemberSuccessStatus(true)
                setMemberErrorStatus(false);
            }).catch(function (error) {
                setMemberUploading(false)
                setMemberErrorStatus(true);
                setMemberSuccessStatus(false)
                //setMemberErrorMessage(error.response.data.detailTh);
            });
        }


    }


    // load reward
    const loadReward = () => {
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/reward/reward?eventId=' + id, auth)
            .then(function (response) {
                setRewardLists(response.data);
                loadMemberReward()
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    const clearAlert = () => {
        setMemberErrorStatus(false)
        setMemberSuccessStatus(false)
    }
    const loadMemberReward = () => {
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/reward/memberreward?eventId=' + id,auth)
            .then(function (response) {
                setRewardOptions(response.data);
               // console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    // load Member
    const loadMember = () => {
        let url = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=" + filter.offset + "&limit=" + filter.limit;
        
        // Add status filter if selected
        if (statusFilter.trim() !== "") {
            url += "&status=" + statusFilter;
        }
        
        // Add search keyword
        if (searchKeyword.trim() !== "") {
            url += "&keyword=" + encodeURIComponent(searchKeyword.trim());
        }
        
        axios.get(url, auth)
            .then(function (response) {
                setMemberLists(response.data);
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    // Load total members count without filter
    const loadTotalMembers = () => {
        if (id === "00") return;
        
        // Get all members count
        const urlAll = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=0&limit=999999";
        
        // Get received members count
        const urlReceived = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=0&limit=999999&status=1";
        
        // Fetch both counts
        Promise.all([
            axios.get(urlAll, auth),
            axios.get(urlReceived, auth)
        ])
        .then(([responseAll, responseReceived]) => {
            setTotalMembersInEvent(responseAll.data.total || 0);
            setTotalReceivedInEvent(responseReceived.data.total || 0);
        })
        .catch(function (error) {
            console.error('Error loading total members:', error);
        });
    }


    //Delete
    const hendleRewardConfirmModal = (rwId: number) => {
        setRewardId(rwId);
        setRewardModalShow(true);
    }
    const hendleMemberConfirmModal = (mbId: number) => {
        setMemberId(mbId);
        setMemberModalShow(true);
    }
    const hendleRewardDelete = () => {
        setRewardModalShow(false)
        axios.delete(process.env.REACT_APP_API_END_POINT + '/v1/Reward/delete?id=' + rewardId,auth)
            .then(function (response) {
                loadReward();
                loadMemberReward();
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    const hendleMemberDelete = () => {
        setMemberModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);
        
        axios.delete(
            `${process.env.REACT_APP_API_END_POINT}/v1/Member/delete?id=${memberId}`,
            auth
        )
        .then(function (response) {
            if (response.status === 200) {
                setMemberSuccessStatus(true);
                setMemberSuccessMessage('ลบข้อมูลเรียบร้อยแล้ว');
                loadMember();
                loadTotalMembers();
            }
        })
        .catch(function (error) {
            console.error('Error deleting member:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        });
    }

    // Checkbox handlers
    const handleSelectMember = (memberId: number) => {
        setSelectedMembers(prev => {
            if (prev.includes(memberId)) {
                return prev.filter(id => id !== memberId);
            } else {
                return [...prev, memberId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedMembers([]);
            setSelectAll(false);
        } else {
            const allIds = memberLists.memberLists.map((item: any) => item.id);
            setSelectedMembers(allIds);
            setSelectAll(true);
        }
    };

    // Bulk delete selected members
    const handleBulkDelete = () => {
        setBulkDeleteModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);

        const deletePromises = selectedMembers.map(id =>
            axios.delete(
                `${process.env.REACT_APP_API_END_POINT}/v1/Member/delete?id=${id}`,
                auth
            )
        );

        Promise.all(deletePromises)
            .then(() => {
                setMemberSuccessStatus(true);
                setMemberSuccessMessage(`ลบข้อมูล ${selectedMembers.length} รายการเรียบร้อยแล้ว`);
                setSelectedMembers([]);
                setSelectAll(false);
                loadMember();
                loadTotalMembers();
            })
            .catch((error) => {
                console.error('Error bulk deleting members:', error);
                setMemberErrorStatus(true);
                setMemberErrorMessage('ไม่สามารถลบข้อมูลบางรายการได้ กรุณาลองใหม่อีกครั้ง');
            });
    };

    // Delete all filtered members
    const handleDeleteAll = () => {
        setDeleteAllModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);
        setIsDeleting(true);

        // Build URL with query parameters
        let deleteUrl = `${process.env.REACT_APP_API_END_POINT}/v1/Member/deleteAll?eventId=${id}`;
        
        if (statusFilter.trim() !== "") {
            deleteUrl += `&status=${statusFilter}`;
        }
        
        if (searchKeyword.trim() !== "") {
            deleteUrl += `&keyword=${encodeURIComponent(searchKeyword.trim())}`;
        }

        axios.delete(deleteUrl, auth)
        .then((response) => {
            setMemberSuccessStatus(true);
            setMemberSuccessMessage('ลบข้อมูลทั้งหมดเรียบร้อยแล้ว');
            setSelectedMembers([]);
            setSelectAll(false);
            loadMember();
            loadTotalMembers();
        })
        .catch((error) => {
            console.error('Error deleting all members:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        })
        .finally(() => {
            setIsDeleting(false);
        });
    };

    const onExportMembers = async () => {
        setIsExporting(true);
        
        // Generate filename with current date and time
        const now = new Date();
        const dateStr = now.getFullYear() + 
            String(now.getMonth() + 1).padStart(2, '0') + 
            String(now.getDate()).padStart(2, '0') + '_' +
            String(now.getHours()).padStart(2, '0') + 
            String(now.getMinutes()).padStart(2, '0') + 
            String(now.getSeconds()).padStart(2, '0');
        const fileName: string = `Event_${id}_Members_${dateStr}`;
        
        try {
            // Fetch all data for export with current filters
            let exportUrl = `${process.env.REACT_APP_API_END_POINT}/v1/member/Members?eventId=${id}&offset=0&limit=999999`;
            
            if (statusFilter.trim() !== "") {
                exportUrl += `&status=${statusFilter}`;
            }
            
            if (searchKeyword.trim() !== "") {
                exportUrl += `&keyword=${encodeURIComponent(searchKeyword.trim())}`;
            }

            const response = await axios.get(exportUrl, auth);
            
            const exportData = response.data.memberLists.map((item: any) => ({
                'EmployeeId': item.employeeId,
                'ItemNumber': item.rewardNumber || '',
                'Recieved': (item.recieved === 1 || item.recieved === '1') ? '1' : '0',
                'EmployeeName': item.namempt || '',
                'Department': item.namcenteng || '',
            }));

            // Create workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            
            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Members");
            
            // Generate buffer and save file
            XLSX.writeFile(workbook, fileName + '.xlsx');
            
            setMemberSuccessStatus(true);
            setMemberSuccessMessage('ส่งออกข้อมูลเรียบร้อยแล้ว');
            
        } catch (error) {
            console.error('Error exporting members:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('ไม่สามารถส่งออกข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        } finally {
            setIsExporting(false);
        }
    };

    const hendleMemberInputType = (e: any) => {
        const { value, name } = e.target
        setMemberInputType(value);
    }
    const handlePageClick = (event: any) => {
        const newOffset = (event.selected * filter.limit) % memberLists.total;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setFilter(oldValues => ({ ...oldValues, ['offset']: newOffset }));
    }

    const handleSearchChange = (e: any) => {
        setSearchKeyword(e.target.value);
    }

    const handleKeyPress = (e: any) => {
        if (e.key === 'Enter') {
            handleSearchSubmit();
        }
    }

    const handleStatusFilterChange = (e: any) => {
        setStatusFilter(e.target.value);
    }

    const handleSearchSubmit = () => {
        setFilter(oldValues => ({ ...oldValues, ['offset']: 0 })); // Reset to first page
        loadMember();
        // Keep focus on search input
        setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, 100);
    }

    const clearAllFilters = () => {
        setSearchKeyword("");
        setStatusFilter("");
        setFilter(oldValues => ({ ...oldValues, ['offset']: 0 })); // Reset to first page
        setTimeout(() => {
            loadMember();
        }, 100);
    }

    // Date validation function
    const validateDates = (startDate: string, endDate: string) => {
        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            return end >= start;
        }
        return true;
    }

    const handleDateChange = (field: 'startDate' | 'endDate', value: string) => {
        setValue(field, value);
        
        // Get the other date value
        const startDateElement = document.getElementById('startDate') as HTMLInputElement;
        const endDateElement = document.getElementById('endDate') as HTMLInputElement;
        
        if (startDateElement && endDateElement) {
            const startValue = field === 'startDate' ? value : startDateElement.value;
            const endValue = field === 'endDate' ? value : endDateElement.value;
            
            if (startValue && endValue && !validateDates(startValue, endValue)) {
                if (field === 'endDate') {
                    endDateElement.setCustomValidity('End Date cannot be earlier than Start Date');
                } else {
                    endDateElement.setCustomValidity('End Date cannot be earlier than Start Date');
                }
            } else {
                endDateElement.setCustomValidity('');
            }
        }
    }

    // Email management functions
    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const addEmail = (email: string) => {
        const trimmedEmail = email.trim().toLowerCase();
        if (trimmedEmail && validateEmail(trimmedEmail) && !emailList.includes(trimmedEmail)) {
            const newEmailList = [...emailList, trimmedEmail];
            setEmailList(newEmailList);
            setValue("eventOwner", newEmailList.join(';'));
            setCurrentEmail("");
        }
    }

    const removeEmail = (emailToRemove: string) => {
        const newEmailList = emailList.filter(email => email !== emailToRemove);
        setEmailList(newEmailList);
        setValue("eventOwner", newEmailList.join(';'));
    }

    const handleEmailInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addEmail(currentEmail);
        }
    }

    const searchOrgUsers = async (query: string) => {
        if (query.length < 2) {
            setOwnerSuggestions([]);
            return;
        }
        setOwnerSearchLoading(true);
        try {
            const response = await axios.get(
                `https://graph.microsoft.com/v1.0/users?$filter=startswith(mail,'${encodeURIComponent(query)}')&$select=displayName,mail&$top=10`,
                { headers: { Authorization: `Bearer ${tokenProfile}` } }
            );
            setOwnerSuggestions((response.data.value || []).filter((u: any) => u.mail));
        } catch {
            setOwnerSuggestions([]);
        } finally {
            setOwnerSearchLoading(false);
        }
    };

    const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCurrentEmail(value);
        if (ownerSearchTimeout.current) clearTimeout(ownerSearchTimeout.current);
        ownerSearchTimeout.current = setTimeout(() => searchOrgUsers(value), 300);
    };

    // Image preview function
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setPreviewImage(event.target?.result as string);
            };
            reader.readAsDataURL(file);
        }
    }

    // ...existing code...
    useEffect(() => {
        if (eventId != null) {
           setLoading(true)
            axios.get(process.env.REACT_APP_API_END_POINT + '/v1/Events/event?eventNumber=' + eventId,auth)
                .then(function (response) {
                    setValue("id", response.data.id);
                    setValue("eventNumber", response.data.eventNumber);
                    setValue("eventName", response.data.eventName);
                    setValue("eventOwner", response.data.owner);
                    // Initialize email list from owner data
                    if (response.data.owner) {
                        const emails = response.data.owner
                            .replace(/[,;]/g, ';')
                            .split(';')
                            .map((email: string) => email.trim().toLowerCase())
                            .filter((email: string) => email.length > 0);
                        setEmailList(emails);
                    }
                    setValue("description", response.data.description);
                    setValue("startDate", response.data.startDate);
                    setValue("endDate", response.data.endDate);
                    setValue("status", response.data.status);
                    setValue("ConfirmStatus", response.data.confirmStatus);
                    setValue("BehalStatus", response.data.behalStatus);
                    // Set preview image if exists
                    if (response.data.image) {
                        setPreviewImage(`data:image/jpeg;base64,${response.data.image}`);
                    }
                    //console.log(response.data.owner);
                    setId(response.data.id);
                    setEventdata(response.data);
                    // Convert memberGroup to number and set default to 1 if invalid
                    const memberGroupValue = response.data.memberGroup;
                    const parsedMemberGroup = memberGroupValue ? parseInt(memberGroupValue.toString()) : 1;
                    setMemberInputType(parsedMemberGroup);
                    setLoading(false)
                })
                .catch(function (error) {
                    // handle error
                    setLoading(false)
                   // console.log(error);
                })
                .finally(function () {
                   setLoading(false)
                    // always executed
                });

        }

    }, [token,eventId])


    useEffect( () => {
        if (!token && inProgress === InteractionStatus.None) {
         acquireGetAccessToken(instance, accounts).then(async (res: any) => {
                setToken(res.accessToken)
                setTokenProfile(res.accessTokenProfile)
                setStateLoad(true)
                const response1 = await axios("https://graph.microsoft.com/v1.0/me/photo/$value", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` },
                    responseType: "arraybuffer"
                });
                const avatar = Buffer.from(response1.data, "binary").toString("base64");
                setPhotoData("data:image/jpeg;base64, " + avatar);
                sessionStorage.setItem("PhotoData", "data:image/jpeg;base64, " + avatar);


                const response2 = await axios("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` }
                });
                setProfile(response2.data);
              //  sessionStorage.setItem("Profile", response2.data);
            }) 
        }
      }, [inProgress]);



      useEffect ( () => {
       // console.log('eventdata===',eventdata.owner);
        // console.log('profile===',profile.mail);
        const CheckRole = async () => {
          //  setLoading(true)
            if (eventdata.owner && profile.mail) {
                try {
                    let ownerArray = eventdata.owner.split(";").map(em => em.trim());
                    const profileMailLower =  await profile.mail.toLowerCase().trim();
                    const ownerExists = await ownerArray.some((em) => em.toLowerCase() === profileMailLower);
                    const groupsData = await callMsGraph(tokenProfile, "/me/transitiveMemberOf/microsoft.graph.group?$top=999");
                    const groupExists = await groupsData.value.some((group:any) => group.id === process.env.REACT_APP_SEC_ADMIN);
                    // console.log("Owner=>", ownerArray);
                    // console.log("ownerExists=>", ownerExists);
                    // console.log("groupExists=>", groupExists);
            
                    if (groupExists || ownerExists) {
                      //   setLoading(false)
                         //setStateLoad(true)
                    } else {
                        // Redirect to access denied page
                        window.location.href = `${window.location.origin}/accessdenied`;
                    }
                } catch(error) {
                    console.error('error=',error);
                    setLoading(false)
                }
           }else{
            setStateLoad(true)
           }
        }

    CheckRole();

    }, [profile.mail, eventdata.owner, tokenProfile])

    useEffect(() => {
        if (id !== "00") {
            loadReward()
            loadMember()
            loadMemberReward()
            loadTotalMembers()
        }

    }, [id])

    useEffect(() => {
        const timer = setTimeout(() => {
            setMemberErrorStatus(false)
            setMemberSuccessStatus(false)
        }, 5000);

        // Cleanup the timer when the component is unmounted
        return () => clearTimeout(timer);
    }, [memberErrorStatus, memberSuccessStatus])
    useEffect(() => {
        if (id !== "00") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [filter.offset])

    useEffect(() => {
        if (id !== "00" && searchKeyword === "") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [searchKeyword])

    useEffect(() => {
        if (id !== "00") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [statusFilter])
    // console.log('stateLoad====',stateLoad);
    // console.log('loading====',loading);
    return (
        <>
        {(!loading && stateLoad) ? <>
            <UserTopbar  token={token}  photoData={photoData} />
            <div className='container mt-4'>
                <div className='card border-0 event-form-tab'>
                    <Tabs
                        defaultActiveKey="event"
                        id="fill-tab-example"
                        className="mb-3"

                    >
                        <Tab eventKey="event" title="Event information" >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <input type='hidden' {...register("id")} value="" />
                                <div className='row mx-5 mt-4'>
                                    <div className='col-12'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className="mb-3">
                                                    <label className="form-label">Event Name <span className="text-danger">*</span></label>
                                                    <input type="text" id="eventName" className="form-control" placeholder="" {...register("eventName", { required: true })}  required />
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="mb-3">
                                                    <label className="form-label">Description</label>
                                                    <textarea className='form-control' rows={10}  {...register("description")} required></textarea>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">Users Confirm Receive</label>
                                                    <select className="form-select" {...register("ConfirmStatus")}>
                                                        <option value="0">No</option>
                                                        <option value="1">Yes</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">Substitute(รับแทน)</label>
                                                    <select className="form-select" {...register("BehalStatus")}>
                                                        <option value="0">No</option>
                                                        <option value="1">Yes</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">Start Date <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="date" 
                                                        {...register("startDate", { required: true })} 
                                                        className="form-control" 
                                                        id="startDate" 
                                                        required 
                                                        onChange={(e) => handleDateChange('startDate', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">End Date <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="date" 
                                                        {...register("endDate", { required: true })} 
                                                        className="form-control" 
                                                        id="endDate" 
                                                        required 
                                                        onChange={(e) => handleDateChange('endDate', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">Status</label>
                                                    <select className="form-select" {...register("status")}>
                                                        <option value="1">Inactive</option>
                                                        <option value="2">Active</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className="mb-3">
                                                    <label className="form-label">Event Image <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="file" 
                                                        className="form-control" 
                                                        id="eventFile" 
                                                        {...register("file", { required: eventId === null })} 
                                                        accept=".jpg,.jpeg,.png"
                                                        required={eventId === null}
                                                        onChange={(e) => {
                                                            handleImageChange(e);
                                                            // Keep the original register onChange functionality
                                                            const originalOnChange = register("file").onChange;
                                                            if (originalOnChange) {
                                                                originalOnChange(e);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Event Image Preview - Full Width Row */}
                                        {previewImage && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Event Image Thumbnail</label>
                                                        <div className="border rounded p-4 text-center bg-light">
                                                            <img 
                                                                src={previewImage} 
                                                                alt="Event Preview" 
                                                                style={{ 
                                                                    maxWidth: '100%', 
                                                                    maxHeight: '300px', 
                                                                    objectFit: 'contain',
                                                                    display: 'block',
                                                                    margin: '0 auto'
                                                                }}
                                                                className="img-fluid"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        <div className="row">
                                            <div className='col-12'>
                                                <div className="mb-3">
                                                    <label className="form-label">Event Owner(s) <span className="text-danger">*</span></label>
                                                    <input type="hidden" {...register("eventOwner")} />
                                                    
                                                    {/* Email Tags Display */}
                                                    {emailList.length > 0 && (
                                                        <div className="mb-2">
                                                            {emailList.map((email, index) => (
                                                                <span key={index} className="badge bg-primary me-2 mb-1 d-inline-flex align-items-center">
                                                                    {email}
                                                                    <button 
                                                                        type="button"
                                                                        className="btn-close btn-close-white ms-2"
                                                                        style={{ fontSize: '0.6em' }}
                                                                        onClick={() => removeEmail(email)}
                                                                        aria-label="Remove email"
                                                                    ></button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    
                                                    {/* Email Search Input */}
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search by email address..."
                                                            value={currentEmail}
                                                            onChange={handleEmailInputChange}
                                                            onKeyPress={handleEmailInputKeyPress}
                                                            onBlur={() => setTimeout(() => setOwnerSuggestions([]), 200)}
                                                            autoComplete="off"
                                                        />
                                                        {ownerSearchLoading && (
                                                            <div className="position-absolute end-0 top-50 translate-middle-y pe-3">
                                                                <span className="spinner-border spinner-border-sm text-secondary" role="status" />
                                                            </div>
                                                        )}
                                                        {ownerSuggestions.length > 0 && (
                                                            <ul className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000, top: '100%' }}>
                                                                {ownerSuggestions.map((user, i) => (
                                                                    <li
                                                                        key={i}
                                                                        className="list-group-item list-group-item-action py-2"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onMouseDown={() => {
                                                                            addEmail(user.mail);
                                                                            setOwnerSuggestions([]);
                                                                        }}
                                                                    >
                                                                        <span className="fw-semibold">{user.displayName}</span>
                                                                        <small className="text-muted ms-2">{user.mail}</small>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>

                                                    {/* Required field indicator */}
                                                    {emailList.length === 0 && (
                                                        <div className="text-danger small mt-1">
                                                            At least one event owner email is required
                                                        </div>
                                                    )}

                                                    <small className="form-text text-muted">
                                                        Type to search org email • Select from dropdown or press Enter to add manually
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 text-end py-3'>
                                        <Button type='reset' className='btn-width me-3 btn-cancel'>Reset</Button> <Button type='submit' variant="success" className='btn-width btn-save'>Save</Button>
                                    </div>
                                </div>

                            </form>
                        </Tab>
                        <Tab eventKey="items" title="Reward Items" disabled={(eventId != null) ? false : true}>
                            <form onSubmit={submitReward(onSubmitReward)}>
                                <div className='row mx-3 align-items-end mt-4'>

                                    <div className='col-4'>
                                        <div className="mb-0">
                                            <label className="form-label">Item Name</label>
                                            <input type="text" className="form-control" placeholder="" {...registerReward("rewardName", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className="mb-0">
                                            <label className="form-label">Item Image</label>
                                            <input type="file" className="form-control"  {...registerReward("file", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="mb-0">
                                            <label className="form-label">Qty. per user</label>
                                            <input type="number" className="form-control" {...registerReward("qty", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <button className="btn btn-add w-100 " type="submit">
                                            <BiGift size={22} /> <span>Add Item</span>
                                        </button>
                                    </div>

                                    <div className='col-12'>
                                        <table className="table items-table mt-4"  >
                                            <thead className='tbl-header'>
                                                <tr>
                                                    <th scope="col">Item Number</th>
                                                    <th scope="col">Image</th>
                                                    <th scope="col">Item Name</th>
                                                    <th scope="col" className='text-center px-4'>Qty per user</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {

                                                    (rewardLists.length > 0) ?
                                                        rewardLists.map(
                                                            (item: any,
                                                                index: number) => (
                                                                <tr key={index}>
                                                                    <td className='fw-bold'> {item.rewardNumber}</td>
                                                                    <td>
                                                                        <img src={`data:image/png;base64,${item.image}`} />
                                                                    </td>

                                                                    <td>{item.rewardName}</td>
                                                                    <td className='text-center'>{item.qty}</td>
                                                                    <td><a className='text-danger' onClick={() => hendleRewardConfirmModal(item.id)}><BiSolidTrash /></a></td>
                                                                </tr>
                                                            )
                                                        )
                                                        :
                                                        <></>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </form>
                        </Tab>
                        <Tab eventKey="employee" title="Receive  Users" disabled={(eventId != null) ? false : true}>
                            <form onSubmit={submitMember(onSubmitMember)}>
                                <div className='row mx-3 align-items-end mt-4'>
                                    <div className={`${(memberInputType.toString() === "3") ? "col-10" : "col-3"}`}>
                                        <div className="mb-0">
                                            <label className="form-label">Type</label>
                                            <select className="form-select" {...registerMember("inputtype")} onChange={(e: any) => hendleMemberInputType(e)} value={memberInputType}>
                                                <option value="1">รหัสพนักงาน</option>
                                                <option value="2">Excel ไฟล์</option>
                                                <option value="3">พนักงานทุกคน</option>
                                            </select>
                                        </div>
                                    </div>
                                    {
                                        (memberInputType.toString() !== "3") ?
                                            (memberInputType.toString() === "2") ?
                                            <>
                                                <div className='col-7'>
                                                    <div className="mb-0">
                                                        <label className="form-label">List of users file (<strong>หมายเหตุ:</strong> ไฟล์ที่อัปโหลดต้องมีชื่อว่า <strong className="text-danger">eventMember.xlsx</strong> เท่านั้น)</label>
                                                        <input type="file" className="form-control" placeholder="" {...registerMember("file", { required: true })} accept=".xlsx,.xls" />
                                                    </div>
                                                </div>
                                            </>
                                                :
                                                <>
                                                    <div className='col-4'>
                                                        <div className="mb-0">
                                                            <label className="form-label">Employee Id 7 Digits</label>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                placeholder="xxxxxxx" 
                                                                {...registerMember("employeeId", { 
                                                                    required: true,
                                                                    pattern: {
                                                                        value: /^\d{7}$/,
                                                                        message: "Employee ID must be exactly 7 digits"
                                                                    }
                                                                })}
                                                                maxLength={7}
                                                                onKeyPress={(e) => {
                                                                    // Allow only numbers
                                                                    if (!/[0-9]/.test(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-3'>
                                                        <div className="mb-0">
                                                            <MultiSelect
                                                                options={rewardOptions}
                                                                value={rewardSelected}
                                                                onChange={setRewardSelected}
                                                                labelledBy="Select"
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            : <></>
                                    }
                                    <div className='col-2'>
                                        <button className="btn btn-add w-100" type='submit' disabled={memberUploading}>
                                            {memberUploading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    <span style={{ color: 'black' }}>Uploading...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <BiUserPlus size={26} /> <span>Add Member</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                    {/* {(memberInputType.toString() === "2") && (
                                        <div className='col-2'>
                                            <a href='./files/eventMember.xlsx' download={true} aria-label="Download Excel Template">
                                                <button className='btn btn-success w-100' type='button' title="Download Template">
                                                    <PiMicrosoftExcelLogoDuotone size={22} /> ตัวอย่างไฟล์ 
                                                </button>
                                            </a>
                                        </div>
                                    )} */}
                                    {
                                        (memberErrorStatus) ?
                                            <div className='col-12'>
                                                <div className='w-100 mt-3 error-dailog'>
                                                    <BiErrorCircle size={22} /> {memberErrorMessage}
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }
                                    {
                                        (memberSuccessStatus) ?
                                            <div className='col-12'>
                                                <div className='w-100 mt-3 success-dailog'>
                                                    <BiCheckCircle size={22} /> {memberSuccessMessage}
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }
                                    <div className='col-12 mt-3'>
                                        <div className="row align-items-end">
                                            <div className="col-lg-8 col-md-8 col-sm-12">
                                                <label className="form-label">Search by Employee ID</label>
                                                <input 
                                                    ref={searchInputRef}
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Enter Employee ID 7 Digits"
                                                    value={searchKeyword}
                                                    onChange={handleSearchChange}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <label className="form-label">Status</label>
                                                <select 
                                                    className="form-select" 
                                                    value={statusFilter}
                                                    onChange={handleStatusFilterChange}
                                                >
                                                    <option value="">ทั้งหมด (All)</option>
                                                    <option value="1">รับของแล้ว (Received)</option>
                                                    <option value="0">ยังไม่รับของ (Not Received)</option>
                                                </select>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <div className="d-flex gap-2 justify-content-between align-items-center flex-wrap">
                                                    <div className="d-flex gap-2">
                                                        <button type="button" className="btn btn-primary" onClick={handleSearchSubmit}>
                                                            <BiSearchAlt size={18} /> Search
                                                        </button>
                                                        {(searchKeyword || statusFilter) && (
                                                            <button type="button" className="btn btn-secondary" onClick={clearAllFilters}>
                                                                Clear Filters
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        {memberInputType.toString() === "2" && (
                                                            <a href='./files/eventMember.xlsx' download={true} aria-label="Download Excel Template">
                                                                <button className='btn btn-info' type='button' title="Download Template">
                                                                    <PiMicrosoftExcelLogoDuotone size={18} /> ตัวอย่างไฟล์ Upload
                                                                </button>
                                                            </a>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-success" 
                                                                onClick={onExportMembers}
                                                                disabled={isExporting}
                                                            >
                                                                {isExporting ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        กำลัง Export...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <PiMicrosoftExcelLogoDuotone size={18} /> Export
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && memberInputType.toString() !== "3" && selectedMembers.length > 0 && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-danger" 
                                                                onClick={() => setBulkDeleteModalShow(true)}
                                                            >
                                                                <BiSolidTrash size={18} /> ลบที่เลือก ({selectedMembers.length})
                                                            </button>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && memberInputType.toString() !== "3" && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger" 
                                                                onClick={() => setDeleteAllModalShow(true)}
                                                                disabled={isDeleting}
                                                            >
                                                                {isDeleting ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        กำลังลบ...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <BiSolidTrash size={18} /> ลบทั้งหมด
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <table className="table user-table  mt-4">
                                            <thead className='tbl-header'>
                                                <tr>
                                                    {memberInputType.toString() !== "3" && (
                                                        <th scope="col" style={{ width: '50px' }}>
                                                            <input 
                                                                type="checkbox" 
                                                                className="form-check-input" 
                                                                checked={selectAll}
                                                                onChange={handleSelectAll}
                                                                disabled={memberLists.memberLists.length === 0}
                                                            />
                                                        </th>
                                                    )}
                                                    <th scope="col">Employee Id</th>
                                                    <th scope="col">Employee Name</th>
                                                    {/* <th scope="col">Email</th> */}
                                                    <th scope="col">Item</th>
                                                    <th scope="col">Depatyment</th>
                                                    <th scope="col">Status</th>
                                                    {memberInputType.toString() !== "3" && (
                                                        <th scope="col" className='text-center'>Action</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (memberLists.memberLists.length > 0) ?
                                                        memberLists.memberLists.map(
                                                            (item: any,
                                                                index: number) => (
                                                                <tr key={index}>
                                                                    {memberInputType.toString() !== "3" && (
                                                                        <td>
                                                                            <input 
                                                                                type="checkbox" 
                                                                                className="form-check-input"
                                                                                checked={selectedMembers.includes(item.id)}
                                                                                onChange={() => handleSelectMember(item.id)}
                                                                            />
                                                                        </td>
                                                                    )}
                                                                    <td>{item.employeeId}</td>
                                                                    <td>{item.namempt}</td>
                                                                    {/* <td>{item.email}</td> */}
                                                                    <td>{item.rewardNumber}</td>
                                                                    <td>{item.namcenteng}</td>
                                                                    <td>
                                                                        <span className={`badge ${item.recieved === 1 || item.recieved === '1' ? 'bg-success' : 'bg-secondary'}`}>
                                                                            {item.recieved === 1 || item.recieved === '1' ? 'Received' : 'Not Received'}
                                                                        </span>
                                                                    </td>
                                                                    {memberInputType.toString() !== "3" && (
                                                                        <td className="text-center"><a className='text-danger' onClick={() => hendleMemberConfirmModal(item.id)}><BiSolidTrash /></a></td>
                                                                    )}
                                                                </tr>
                                                            )
                                                        )
                                                        :
                                                        <tr>
                                                            <td colSpan={memberInputType.toString() !== "3" ? 7 : 6} className='text-center p-5 text-secondary'>ไม่มีข้อมูลสมาชิก</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="text-muted">
                                                <strong>Total Members:</strong> {totalMembersInEvent} คน | 
                                                <strong> Received:</strong> {totalReceivedInEvent} คน
                                                {(searchKeyword || statusFilter) && (
                                                    <span className="ms-2">
                                                        (ผลการค้นหา: {memberLists.total} รายการ)
                                                    </span>
                                                )}
                                            </div>
                                            <ReactPaginate
                                                className='pagination mb-0'
                                                breakLabel="..."
                                                nextLabel=">"
                                                onPageChange={(e: any) => handlePageClick(e)}
                                                pageRangeDisplayed={5}
                                                pageCount={memberLists.totalPages}
                                                previousLabel="<"
                                                renderOnZeroPageCount={null}
                                                pageClassName='page-item'
                                                pageLinkClassName='page-link'
                                                activeClassName='active'
                                                previousClassName='page-item'
                                                nextClassName='page-item'
                                                previousLinkClassName='page-link'
                                                nextLinkClassName='page-link'
                                            />
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </Tab>
                    </Tabs>

                </div>

            </div>
            <RewardConfirmModal
                show={rewardModalShow}
                onHide={() => setRewardModalShow(false)}
                onDelete={() => hendleRewardDelete()}
            />
            <MemberConfirmModal
                show={memberModalShow}
                onHide={() => setMemberModalShow(false)}
                onDelete={() => hendleMemberDelete()}
            />
            <BulkDeleteConfirmModal
                show={bulkDeleteModalShow}
                onHide={() => setBulkDeleteModalShow(false)}
                onDelete={() => handleBulkDelete()}
                count={selectedMembers.length}
            />
            <DeleteAllConfirmModal
                show={deleteAllModalShow}
                onHide={() => setDeleteAllModalShow(false)}
                onDelete={() => handleDeleteAll()}
                total={memberLists.total}
                filters={{
                    keyword: searchKeyword,
                    status: statusFilter
                }}
            />
            <SuccessModal
                show={successModalShow}
                onHide={() => setSuccessModalShow(false)}
                result={createStatus}
                eventId={createEvId}
            />
         </>:<><LoadingScreen /></>
        }
        </>

    )
}

Events.propTypes = {

}

export default Events

